import { FeedbackRequestWithDetails } from '@/common/types/databaseTypes';
import { Box, Center, Flex, Loader, Text } from '@mantine/core';
import { FeedbackRequestCard } from '../utils/FeedbackCardRenderers';
import { useTranslation } from 'react-i18next';

interface SentRequestsTabProps {
    sentRequests: FeedbackRequestWithDetails[] | undefined;
    isLoadingSentRequests: boolean;
    notiParams: {
        workspaceName: string;
        workspaceImageUrl: string;
    };
}

/**
 * 보낸 요청 탭 컴포넌트
 */
const SentRequestsTab = ({
    sentRequests,
    isLoadingSentRequests,
    notiParams,
}: SentRequestsTabProps) => {
    const { t } = useTranslation(['feedback']);

    return (
        <>
            {isLoadingSentRequests ? (
                <Flex justify="center" align="center" h={200}>
                    <Loader />
                </Flex>
            ) : sentRequests && sentRequests.length > 0 ? (
                <Box
                    flex={1}
                    pr={16}
                    mr={16}
                    style={{ overflowY: 'auto' }}
                    className="custom-scrollbar"
                >
                    {sentRequests.map(request => (
                        <FeedbackRequestCard
                            key={request.id}
                            request={request}
                            isReceived={false}
                            notiParams={notiParams}
                        />
                    ))}
                </Box>
            ) : (
                <Center h="100%" py="xl" ta="center">
                    <Text c="dimmed" mt="md">
                        {t('placeHolder.sentRequest')}
                    </Text>
                </Center>
            )}
        </>
    );
};

export default SentRequestsTab;
